const NAME = 'accessUrls';

export default {
  NAME
};
